import { Box, type BoxProps, Container, Grid, Typography } from '@mui/material'

export type NumbersProps = BoxProps &
  Partial<{
    pretitle: string
    title: string
    subtitle: string
    text: string
    items: { value: string; description: string }[]
    is_first: boolean
  }>

const Numbers = ({ pretitle, title, subtitle, text, items, is_first, ...props }: NumbersProps) => {
  return (
    <Box {...props}>
      <Container>
        <Grid container>
          <Grid size={{ xs: 4, sm: 7, md: 4 }} offset={{ xs: 0, md: 1 }}>
            <Box
              sx={{
                display: 'grid',
                rowGap: 2
              }}
            >
              {pretitle ? (
                <Typography variant="overline" color="text.secondaryContrastText">
                  {pretitle}
                </Typography>
              ) : null}

              {title ? (
                <Typography
                  variant="h3"
                  component={is_first ? 'h1' : 'h2'}
                  color="text.secondaryContrastText"
                >
                  {title}
                </Typography>
              ) : null}

              {subtitle ? (
                <Typography variant="textLarge" color="text.primary" component="span">
                  {subtitle}
                </Typography>
              ) : null}

              {text ? (
                <Typography variant="textRegular" color="text.primary" component="p">
                  {text}
                </Typography>
              ) : null}
            </Box>
          </Grid>

          {/**
           * numbers grid
           */}
          <Grid
            container
            size={{ xs: 4, sm: 8, md: 6 }}
            columns={{ xs: 4, sm: 8, md: 6 }}
            offset={{ xs: 0, md: 1 }}
          >
            {items?.map((item, index) => (
              <Grid key={`item-${index}`} size={{ xs: 4, sm: 4, md: 3 }}>
                <Box sx={{ display: 'grid', gap: 1 }}>
                  <Typography variant="h1" color="primary.main" component="span">
                    {item.value}
                  </Typography>

                  <Typography variant="textRegular" color="text.secondaryContrastText">
                    {item.description}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default Numbers
